class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

window.cartAction = async function (
  endpoint,
  {
    method = 'POST',
    body = null,
    refreshCart = true,
    onSuccess = null,
    onError = null
  } = {}
) {
  try {
    const response = await fetch(endpoint, {
      method,
      headers: {
        'Content-Type': 'application/json'
      },
      body: body ? JSON.stringify(body) : null
    });

    if (!response.ok) {
      throw new Error(`Request failed: ${response.status}`);
    }

    const data = await response.json();

    if (refreshCart) {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }

    onSuccess?.(data);

    return data;
  } catch (error) {
    console.error('Cart action error:', error);
    onError?.(error);
    throw error;
  }
};
// await window.cartAction('/cart/clear.js');


function refreshMiniCart(openCart = false) {
  const miniCart = document.querySelector('mini-cart');

  if (!miniCart) return;

  fetch(`${window.location.pathname}?sections=mini-cart,cart-icon-bubble,mobile-cart-icon-bubble`)
    .then((response) => response.json())
    .then((sections) => {
      miniCart.getSectionsToRender().forEach((section) => {
        const target = document.getElementById(section.id);

        if (target && sections[section.section]) {
          target.innerHTML = miniCart.getSectionInnerHTML(
            sections[section.section],
            section.selector
          );
        }
      });

      document.dispatchEvent(new CustomEvent('cartdrawer:refreshed'));

      if (openCart) {
        miniCart.open();
      }
    })
    .catch((error) => {
      console.error('Mini cart refresh failed:', error);
    });
}

document.addEventListener('cart:refresh', () => {
  refreshMiniCart();
});

document.dispatchEvent(new CustomEvent('cart:refresh'));

window.removeCartItem = async function (lineIndex) {
  try {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        line: Number(lineIndex),
        quantity: 0,
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to remove cart item');
    }

    const cart = await response.json();

    document.dispatchEvent(new CustomEvent('cart:refresh'));

    return cart;
  } catch (error) {
    console.error('Remove cart item error:', error);
    throw error;
  }
};

document.addEventListener('click', function (event) {
  const removeLink = event.target.closest('.delete-product');

  if (!removeLink) return;

  event.preventDefault();

  const removeButton = removeLink.closest('cart-remove-button');

  if (!removeButton) return;

  const lineIndex = removeButton.dataset.index;

  if (!lineIndex) return;

  removeCartItem(lineIndex);
});

customElements.define('mini-cart', MiniCart);
